import { render, staticRenderFns } from "./modal-explainer.vue?vue&type=template&id=2b494a7d&scoped=true"
import script from "./modal-explainer.vue?vue&type=script&lang=js"
export * from "./modal-explainer.vue?vue&type=script&lang=js"
import style0 from "./modal-explainer.vue?vue&type=style&index=0&id=2b494a7d&prod&lang=scss"
import style1 from "./modal-explainer.vue?vue&type=style&index=1&id=2b494a7d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b494a7d",
  null
  
)

export default component.exports